import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { DealActionBarSkeleton as n } from "../DealActionBar/skeleton.js";
import { DealButtonSkeleton as r } from "../DealButton/style.js";
import { DealActionContainerSkeleton as a, DealStampSkeletonComponent as i } from "./style.js";
function c({
  hasSaveButton: t
}) {
  return /* @__PURE__ */ o(a, { children: [
    /* @__PURE__ */ e(i, { width: "128px", animate: !0 }),
    /* @__PURE__ */ e(r, { animate: !0 }),
    /* @__PURE__ */ e(n, { hasSaveButton: t })
  ] });
}
export {
  c as DealPageActionSkeleton
};
